<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import html2pdf from 'html2pdf.js'
import Widget from '../../dashboard/widget'
import { h } from 'vue';

/**
 * Dashboard-1 Component
 */
export default {
  page: {
    title: '360MDR Real Dashboard',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    Widget
  },
  props: {
    name: {
      type: String,
      default: 'main.json'
    }
  },
  data () {
    return {
      finishedWidgetsCount: 0,
      widgetsStatus: [],
      currentDateTime: new Date().toLocaleString('en-GB').replace(',', ''),
      dashboard: {
        widgets: [
          {
            source: '/auto/fp/ops/count?start=0&partial=yes',
            name:
              'ESTIMADO DE COSTOS EVITADOS GRACIAS AL CIERRE AUTOMÁTICO EN CORTEX DE FALSOS POSITIVOS BIEN CONOCIDOS',
            id: 'widget22',
            cols: 'col-md-12',
            height_class: 'short_widget',
            component: 'multicolumn',
            range: true,
            error: 'No hay eventos de automatización de EDL para mostrar.',
            cardStyle: "overflow:auto",
            refresh: 60000
          },
          {
            source: '/auto/edl/cortex/ops/count?start=0&partial=yes',
            name:
              'ESTIMADO DE COSTOS EVITADOS POR DIRECCIONES IP AUTOMATICAMENTE AGREGADAS Y REMOVIDAS A EDLs - CORTEX',
            id: 'widget22',
            cols: 'col-md-12',
            height_class: 'short_widget',
            component: 'multicolumn',
            range: true,
            error: 'No hay eventos de automatización de EDL para mostrar.',
            cardStyle: "overflow:auto",
            refresh: 60000
          },
          {
            source: '/auto/edl/entra/ops/count?start=0&partial=yes',
            name:
              'ESTIMADO DE COSTOS EVITADOS POR DIRECCIONES IP AUTOMATICAMENTE AGREGADAS Y REMOVIDAS A EDLs - ENTRA',
            id: 'widget32',
            cols: 'col-md-12',
            height_class: 'short_widget',
            component: 'multicolumn',
            range: true,
            error: 'No hay eventos de automatización de EDL para mostrar.',
            cardStyle: "overflow:auto",
            refresh: 60000
          },
          {
            source: '/auto/scanep/ops/count?start=0&partial=yes',
            name:
              'ESTIMADO DE COSTOS EVITADOS GRACIAS A LOS ESCANEOS AUTOMÁTICOS DE ENDPOINTS DE CORTEX',
            id: 'widget22',
            cols: 'col-md-12',
            height_class: 'short_widget',
            component: 'multicolumn',
            range: true,
            error:
              'No hay eventos de automatización de escaneos de endpoints para mostrar.',
            cardStyle: "overflow:auto",
            refresh: 60000
          },
          {
            source: '/auto/userlocalcreation/ops/count?start=0&partial=yes',
            name:
              'ESTIMADO DE COSTOS EVITADOS GRACIAS A LA ELIMINACIÓN AUTOMATIZADA DE CUENTAS CREADAS DE USUARIOS LOCALES',
            id: 'widget22',
            cols: 'col-md-12',
            height_class: 'short_widget',
            component: 'multicolumn',
            range: true,
            error:
              'No hay eventos de automatización de escaneos de endpoints para mostrar.',
            cardStyle: "overflow:auto",
            refresh: 60000
          },
          {
            source: '/auto/otxpulses/ops/count?start=0&partial=yes',
            name:
              'ESTIMADO DE COSTOS EVITADOS GRACIAS A LA INCLUSIÓN AUTOMATIZADA DE INDICADORES OBTENIDOS DE PULSOS DE OTX',
            id: 'widget22',
            cols: 'col-md-12',
            height_class: 'short_widget',
            component: 'multicolumn',
            range: true,
            error:
              'No hay eventos de automatización de inclusión automatizada de indicadores obtenidos de pulsos de OTX para mostrar.',
            cardStyle: "overflow:auto",
            refresh: 60000
          }
        ]
      },
      pdfConfig: {
        margin: 0.2,
        filename: 'Reporte Estadisticas Automatización.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, dpi: 96, letterRendering: false, width: 1280 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
        __pagebreak: { mode: 'avoid-all', before: '#page2el' },
        _pageBreak: { mode: 'css', before: '.break-page', after: '.break-page' }
      },
      // jsonDef: '@src/router/views/pages/dashboard/data/'+name,
      appConfig:
        process.env.NODE_ENV === 'production'
          ? require('@src/app.config')
          : require('@src/app.config.dev')
    }
  },
  computed: {},
  mounted () {
    // console.log(this.jsonDef)
  },
  methods: {
    widgetFinished (id, ok, aux) {
      this.finishedWidgetsCount += 1
      this.widgetsStatus.push({ id: id, ok: ok, aux: aux })
    },
    downloadPdf () {
      const element = document.getElementById('pdfcontent')
      element.style.backgroundColor = 'white'
      html2pdf(element, this.pdfConfig)
      setTimeout(() => {
        element.style.backgroundColor = 'rgb(237, 239, 243)'
      }, 1000)
    }
  }
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12" style="text-align:center;">
        <br>
        <template v-if="finishedWidgetsCount === dashboard.widgets.length">
          <b-button class="btn btn-primary btn-sm mr-1" variant="light" @click="downloadPdf">
            Download PDF
          </b-button>
        </template>
        <template v-else>
          <span>
            Generating...
          </span>
        </template>
      </div>
    </div>
    <br>
    <div id="pdfcontent"
      style="width:1280px;background-color: rgb(237, 239, 243); break-after: page; clear: both;padding-left:20px;padding-right:20px;">
      <!-- style="width:1280px;background-color: rgb(237, 239, 243); break-after: page; clear:
      both;padding-left:20px;padding-right:20px;" -->

      <section slot="pdf-content">
        <h3 style="text-align: center;">
          Estadisticas Acumuladas de Automatización
        </h3>
        <h4 style="text-align: center;">{{ currentDateTime }}</h4>
        <!-- <div class="container" style="max-width: 1420px !important;"> -->
        <div class="row page-title align-items-center" />
        <template v-for="(widget, index) in dashboard.widgets">
          <!-- <div :class="widget.cols">
						<span><h5>{{ widget.name }}</h5></span>
						<b-card no-body class="text-center" style="line-height:300px">
							{{ widget.component }}
						</b-card>
					</div> -->
          <Widget :key="index" :title="widget.name" :component="widget.component" :source="widget.source"
            :series="widget.series" :cols="widget.cols" :trend="widget.trend" :wclass="widget.class" :type="widget.type"
            :card-style="widget.cardStyle" :categories="widget.categories" :colors="widget.colors"
            :colors-by-label="widget.colorsByLabel" :range="widget.range" :start="startEpoch" :end="endEpoch"
            @finished="widgetFinished" />
        </template>
      </section>
    </div>
  </Layout>
</template>

<style scoped>
.break-page {
  page-break-before: always;
  page-break-after: always;
}
</style>
